import { render, staticRenderFns } from "./FirstRun.vue?vue&type=template&id=b5c47bc8&"
import script from "./FirstRun.vue?vue&type=script&lang=js&"
export * from "./FirstRun.vue?vue&type=script&lang=js&"
import style0 from "./FirstRun.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports